/* libs */
import React from "react";
import PropTypes from "prop-types";

/* components */
import {
	BorderStylePicker,
	ColorPicker,
	FileInput,
	NumberInput,
	CheckBox,
	ShadowInput,
	GradientInput,
} from "../../../../../components/shared/Forms";
import { renderFields } from "./helper";

const Container = ({ state, checkForEmptyValues, primaryStatePath, currentStatePath, hideFieldRowBorder = false }) => {
	const fields = [
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Background Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<NumberInput
			field="marginVertical"
			id="marginVertical"
			placeholder="Vertical Margin"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="marginHorizontal"
			id="marginHorizontal"
			placeholder="Horizontal Margin"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingVertical"
			id="paddingVertical"
			placeholder="Vertical Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingHorizontal"
			id="paddingHorizontal"
			placeholder="Horizontal Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<BorderStylePicker
			field="borderStyle"
			id="borderStyle"
			placeholder="Border Styles"
			themeBuilderInputType="BorderStylePicker"
		/>,
		<ColorPicker
			field="borderColor"
			id="borderColor"
			placeholder="Border Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<NumberInput
			field="borderWidth"
			id="borderWidth"
			placeholder="Border Width"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="borderRadius"
			id="borderRadius"
			placeholder="Border Radius"
			max={768}
			themeBuilderInputType="NumberInput"
		/>,
		<CheckBox
			field="borderTopOn"
			id={`${state}-borderTopOn`}
			label="Border Top"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderLeftOn"
			id={`${state}-borderLeftOn`}
			label="Border Left"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderRightOn"
			id={`${state}-borderRightOn`}
			label="Border Right"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderBottomOn"
			id={`${state}-borderBottomOn`}
			label="Border Bottom"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<ShadowInput field="boxShadow" id="boxShadow" placeholder="Shadow" themeBuilderInputType="ShadowInput" />,
	];

	return hideFieldRowBorder ? (
		<React.Fragment>{renderFields(fields)}</React.Fragment>
	) : (
		<React.Fragment>{checkForEmptyValues(primaryStatePath, currentStatePath, fields)}</React.Fragment>
	);
};

Container.propTypes = {
	state: PropTypes.string.isRequired,
	checkForEmptyValues: PropTypes.func.isRequired,
	primaryStatePath: PropTypes.string.isRequired,
	currentStatePath: PropTypes.string.isRequired,
};

export default Container;
